import styled from 'styled-components';
import { motion } from 'framer-motion';
export var Container = styled.div.withConfig({
  displayName: "Analysisstyles__Container",
  componentId: "keen-query-creator__sc-u86gf7-0"
})(["&&&{position:relative;}"]);
export var List = styled.ul.withConfig({
  displayName: "Analysisstyles__List",
  componentId: "keen-query-creator__sc-u86gf7-1"
})(["&&&{padding:0;margin:0;list-style:none;}"]);
export var Groups = styled.div.withConfig({
  displayName: "Analysisstyles__Groups",
  componentId: "keen-query-creator__sc-u86gf7-2"
})(["&&&{padding:10px 0;}&&& ", " + ", "{margin-top:14px;}"], List, List);
export var TooltipContainer = styled(motion.div).withConfig({
  displayName: "Analysisstyles__TooltipContainer",
  componentId: "keen-query-creator__sc-u86gf7-3"
})(["&&&{font-size:13px;line-height:17px;font-family:'Lato Regular',sans-serif;width:160px;position:absolute;top:", "px;transform:translateX(100%);}"], function (props) {
  return props.tooltipY;
});